import { useApi } from '~/api';
import { components } from '~~/api-types';

export type UserDashboardResponseDto =
  components['schemas']['UserDashboardResponseDto'];
export type UserDashboardConfigDto =
  components['schemas']['UserDashboardConfigDto'];
export type UserDashboardSectionDto =
  components['schemas']['UserDashboardSectionDto'];
export type UserDashboardHubDto = components['schemas']['UserDashboardHubDto'];
export type UserDashboardModuleDto =
  components['schemas']['UserDashboardModuleDto'];
export type DashboardSpotlightConfigDto =
  components['schemas']['DashboardSpotlightConfigDto'];

export enum DashboardSectionType {
  HUB = 'hub',
  MODULE = 'module',
  SPOTLIGHT = 'spotlight',
}

export const apiGetUserDashboard = (): Promise<UserDashboardResponseDto> => {
  const api = useApi();
  return api('/app/dashboard');
};
